export const SET_PROJECTS = 'SET_PROJECTS'
export const SEARCH = 'SEARCH'
export const SET_SELECTED_PROJECT = 'SET_SELECTED_PROJECT'
export const SET_SELECT_PROJECT_TYPE = 'SET_SELECT_PROJECT_TYPE'
